package gr.tech.GRAttestation.models.storeusers

@kotlinx.serialization.Serializable
data class StoreUsersDTO(
    val uuid: String,
    val email: String,
    val firstName: String?,
    val lastName: String?,
    val notes: String?,
    val storeId: Int,
    val status: Short,
    val disabledAt: String?,
    val deletedAt: String?,
    val createdAt: String,
    val createdByAdminUuid: String,
    val updatedAt: String,
    val updatedByAdminUuid: String,
    val lastLogin: String?,

    // augment
    val storeName: String?,
    val isInvite: Boolean,
)